import { useTranslation } from "react-i18next";

import { Alert } from "@/ui/alert";

import "./intervention-followup-alert.style.less";

export const InterventionFollowupAlert = () => {
  const { t } = useTranslation();

  return (
    <Alert
      display
      type="info"
      className="intervention-followup-alert"
      title={
        <ul>
          <li>{t("intervention:followUp.info.pictures")}</li>
          <li>{t("intervention:followUp.info.recommendations")}</li>
        </ul>
      }
      showIcon={false}
      closable={false}
    />
  );
};
